/** Вид тоста — влияет на акцентный цвет и полосу прогресса. */
export enum ToastVariant {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}
